import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { getCookie } from '@/util';


interface AuthContextType {
  logged: boolean;
  login: () => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [logged, setLogged] = useState<boolean>(false);

  // 登录函数
  const login = () => {
    setLogged(true);
  };

  // 登出函数
  const logout = () => {
    setLogged(false);
    document.cookie = 'access-token=""';
  };

  useEffect(() => {
    const accessToken = getCookie('access-token');
    if (accessToken) {
      setLogged(true);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ logged, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

